import { render, staticRenderFns } from "./questionSuccess.vue?vue&type=template&id=b81523c0&scoped=true"
import script from "./questionSuccess.vue?vue&type=script&lang=js"
export * from "./questionSuccess.vue?vue&type=script&lang=js"
import style0 from "./questionSuccess.vue?vue&type=style&index=0&id=b81523c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81523c0",
  null
  
)

export default component.exports